<template>

  <div class="wrapper">

    <!-- <h2>How others work it</h2> -->
    <h2>Gift vouchers are available for all&nbsp;classes</h2>

    <img class="gift-card" :src="cardImage" alt="">

    <div class="action">
      <a href="https://shop.hatopress.net/products/gift-card" target="_blank" >Buy Now</a>
    </div>

  </div>

</template>

<script>

export default {
  data () {
    return {
      cardImage: require('../assets/gift-compressed.png')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper {
  text-align: center;
  background: #f3f3f3;
  margin: 0 0;
  padding: 2rem 0 4rem;
}
img.gift-card {
  display: block;
  width: 80%;
  max-width: 400px;
  margin: 1rem auto 2rem;
}
.action a {
  display: inline-block;
  /*font-size: .8em;*/
  margin: 0 1em;
  padding: .6em 1.5em;
  /*border: 1px solid;*/
  border-radius: 8px;
  border-radius: 5px;
  background: hsl(344, 100%, 90%);
}
.action a:hover {
  background: hsl(344, 100%, 85%);
}



@media screen and (max-width: 768px) {
}
@media screen and (max-width: 640px) {
  .wrapper {
    /*padding: 1rem;*/
    padding: 1rem auto 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// Gift.vue?5974fd51